import React, { useEffect, useState, useMemo } from "react";
import CAMHeader from "../../../components/Header/CAMHeader";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import { Box } from "@mui/material";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import SummaryTable from "./SummaryTable";
import DropdownsBar from "../../analytics/header/ProductSiteUnitSelector";
import HeadComp from "./HeadComp";
import Pagination from "../../../components/Pagination/index";
import Loader from "../../../components/Loader/loader";
import { useDispatch, useSelector } from "react-redux";
import * as review from "../../../redux/review/action";
import debounce from "lodash.debounce";
import BatchFilterPopup from "./BatchFilterPopup";
import SnackBar from "../../../components/Snackbars/CustomizedSnackbars";
import ReportPopup from "../../../components/DialogBox/ErrorDialog";
import * as types from "../../../redux/review/types";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { use } from "react";
import { formatLocal } from "../../../utility";
import { hasPermission } from "../../../utils/permissions";
import {
  MANAGE_DATA_MODULE,
  MANAGE_DATA_PERMISSIONS,
} from "../../../constants/permissions";

const Index = () => {
  const canViewUploadSummary = hasPermission(
    MANAGE_DATA_MODULE,
    MANAGE_DATA_PERMISSIONS.VIEW_BATCH_LIST,
  );
  const [page, setPage] = useState(1);
  const rowData = useSelector((state) => state?.reviewReducer?.summaryList);
  const downloadTemp = useSelector(
    (state) => state?.reviewReducer?.downloadTemp
  );
  const rowsPerPage = 50;
  const dispatch = useDispatch();
  const { product, site, unitOfOperation } = useSelector(
    (state) => state.shared?.productSitesUopValues || {}
  );
  const [search, setSearch] = useState();
  const [debouncedSearch, setDebouncedSearch] = useState();
  const [selectedCheck, setSelectedCheck] = useState([]);
  const [open, setOpen] = useState(false);
  const [filters, setFilters] = useState({
    created_start_date: "",
    created_end_date: "",
    batch_status: "",
  });
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [openReportModal, setOpenReportModal] = useState(false);
  const [reportType, setReportType] = useState("");
  const [reportData, setReportData] = useState(null);

  useEffect(() => {
    if (downloadTemp?.status === 200) {
      setSnack({
        open: true,
        message: "Success",
        severity: "success",
      });
      const a = document.createElement("a");
      a.href = downloadTemp?.data;
      a.click();
      URL.revokeObjectURL(downloadTemp?.data);
    } else if (downloadTemp?.message) {
      setSnack({
        open: true,
        message: downloadTemp?.message,
        severity: "error",
      });
      setOpen(false);
    }
    dispatch({ type: types.CLEAR_DOWNLOAD_TEMPLATE });
  }, [downloadTemp?.data]);

  const handleChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleReset = () => {
    setFilters({
      created_start_date: "",
      created_end_date: "",
      batch_status: "",
    });
    getListData(1, true);
  };

  const handleGenerate = () => {
    setPage(1);
    getListData(1);
  };

  const debouncedSetValue = useMemo(
    () =>
      debounce((val) => {
        setDebouncedSearch(val);
      }, 700),
    []
  );

  const handleSearch = (e) => {
    setSearch(e.target.value);
    debouncedSetValue(e.target.value);
  };

  useEffect(() => {
    if (unitOfOperation?.id) {
      getListData(1);
    }
  }, [unitOfOperation, debouncedSearch]);

  const getListData = (page, reset = false) => {
    if (!canViewUploadSummary) return;
    const params = {
      page: page,
      unit_op_id: unitOfOperation?.id,
      page_size: rowsPerPage,
    };
    // params.page_size = rowsPerPage;
    if (reset) return dispatch(review.getSummaryList(params));
    if (filters.created_start_date) params.start_date = formatLocal(filters.created_start_date);
    if (filters.created_end_date) params.end_date = formatLocal(filters.created_end_date);
    if (filters.batch_status) params.status = filters.batch_status;
    if (debouncedSearch) params.search = debouncedSearch;
    dispatch(review.getSummaryList(params));
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    getListData(value);
  };

  const handleCheckBox = (value) => {
    if (selectedCheck.includes(value)) {
      setSelectedCheck(selectedCheck.filter((item) => item !== value));
    } else {
      setSelectedCheck([...selectedCheck, value]);
    }
  };

  const handleMenuOptionDownload = (row, option) => {
    const doc = new jsPDF();

    if (option === "success") {
      const labelMap = {
        ingested_file_id: "Ingested File Name",
        rows_inserted: "Rows Inserted",
        batch_ids_ingested: "Batch IDs Ingested",
        duplicate_batches_skipped: "Duplicate Batches Skipped",
        duplicate_batches_updated: "Duplicate Batches Updated",
      };

      // ✅ Title
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");
      doc.text("Ingestion Report", 14, 15);

      // ✅ Subtitle / timestamp
      // doc.setFontSize(10);
      // doc.setFont("helvetica", "normal");
      // doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 22);

      // ✅ Section 1: File Details
      autoTable(doc, {
        startY: 25,
        head: [["File Details", "Value"]],
        body: [
          [labelMap.ingested_file_id, row.file_name],
          [labelMap.rows_inserted, row.success_logs.rows_inserted],
        ],
        theme: "grid",
        headStyles: { fillColor: [233, 233, 233], textColor: [0, 0, 0] },
        styles: { fontSize: 10, cellPadding: 3 },
      });

      // ✅ Section 2: Batch Information
      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 10,
        head: [["Batch Information", "Value"]],
        body: [
          [
            labelMap.batch_ids_ingested,
            row.success_logs.batch_ids_ingested?.join(", "),
          ],
          [
            labelMap.duplicate_batches_skipped,
            row.success_logs.duplicate_batches_skipped?.join(", "),
          ],
          [
            labelMap.duplicate_batches_updated,
            row.success_logs.duplicate_batches_updated?.join(", "),
          ],
        ],
        theme: "grid",
        headStyles: { fillColor: [233, 233, 233], textColor: [0, 0, 0] },
        styles: { fontSize: 10, cellPadding: 3 },
        didParseCell: function (tableData) {
          if (
            tableData.row.section === "head" &&
            tableData.column.index === 1
          ) {
            tableData.cell.styles.textColor = [0, 0, 0];
            return; // stop further changes for header
          }
          // Green for ingested batches
          if (tableData.row.index === 0 && tableData.column.index === 1) {
            tableData.cell.styles.textColor = [0, 150, 0];
          }
          // Red for skipped duplicates
          if (tableData.row.index === 1 && tableData.column.index === 1) {
            tableData.cell.styles.textColor = [200, 0, 0];
          }
        },
      });
      doc.save(`${unitOfOperation.name}_Ingestion_Report.pdf`);
    } else if (option === "filelogs") {
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");
      doc.text("File Logs", 14, 15);
      autoTable(doc, {
        startY: 30,
        head: [["File Name", "Logs"]],
        body: [[row.file_name, row.file_logs]],
        theme: "grid",
        headStyles: { fillColor: [233, 233, 233], textColor: [0, 0, 0] },
        styles: { fontSize: 10, cellPadding: 3 },
      });
      doc.save(`${unitOfOperation.name}_file_error_logs.pdf`);
    } else {
      doc.text(row?.file_name?.split(".")[0] + ": Error logs", 14, 10);
      const columns = [
        { header: "S.No", dataKey: "sno" },
        { header: "Batch ID", dataKey: "batch_id" },
        { header: "Sheet", dataKey: "sheet" },
        { header: "Row", dataKey: "row" },
        { header: "Column", dataKey: "column" },
        { header: "Error Type", dataKey: "error_type" },
        { header: "Description", dataKey: "description" },
        { header: "Value", dataKey: "got_value" },
      ];
      // ✅ Map JSON to table rows
      const rows = row.error_logs.map((err, index) => ({
        sno: index + 1,
        batch_id: err.batch_id,
        sheet: err.sheet,
        row: err.row,
        column: err.column,
        error_type: err.error_type,
        description: err.description,
        got_value: err.got_value ?? "",
      }));

      autoTable(doc, {
        columns: columns,
        body: rows,
        startY: 15,
        theme: "grid",
        headStyles: { fillColor: [233, 233, 233], textColor: [0, 0, 0] },
        styles: { fontSize: 8, cellPadding: 2, overflow: "linebreak" },
        columnStyles: {
          description: { cellWidth: 50 },
          got_value: { cellWidth: 30 },
        },
      });
      doc.save(`${unitOfOperation.name}_error_logs.pdf`);
    }
  };

  const handleClick = (row, option) => {
    if (option === "success") {
      setReportType("success");
      setReportData(row);
    } else if (option === "filelogs") {
      setReportType("filelogs");
      setReportData(row);
    } else {
      const rows = row.error_logs.map((err, index) => ({
        sno: index + 1,
        batch_id: err.batch_id,
        sheet: err.sheet,
        row: err.row,
        column: err.column,
        error_type: err.error_type,
        description: err.description,
        got_value: err.got_value ?? "",
      }));

      setReportType("error");
      setReportData({
        file_name: row.file_name,
        errors: rows,
        summary:row?.summary
      });
    }
    setOpenReportModal(true);
  };

  const onDownloadClick = async () => {
    dispatch(
      review.downloadTemplate({
        product_id: product?.id,
        site_id: site?.id,
        unit_op_id: unitOfOperation?.id,
      })
    );
  };

  const filterOptions = [
    { label: "Success", value: "Success" },
    { label: "Failed", value: "Failed" },
  ];

  return (
    <Box>
      <CAMHeader />
      <CAMDrawer />
      <InvestigatorContainer>
        <DropdownsBar />

        <>
          <HeadComp
            text="Review"
            isButton={false}
            buttonText={"Upload Data"}
            handleSearch={handleSearch}
            search={search}
            handleClickFilter={() => setOpen(true)}
            // anchorFilter={open}
            handleCloseFilter={() => setOpen(false)}
            selectedCheck={selectedCheck}
            onDownloadClick={onDownloadClick}
            placeholder="Search By File Name"
          />

          <Box
            mt={1}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "calc(100vh - 165px)",
            }}
          >
            <SummaryTable
              data={rowData || []}
              // data={[]}
              onView={handleClick}
              selectedCheck={selectedCheck}
              handleCheckBox={handleCheckBox}
              handleMenuOption={handleClick}
              handleMenuOptionDownload={handleMenuOptionDownload}
              moreOption={["Success Logs", "Error Logs"]}
            />
            {rowData?.loader && <Loader />}
            <Pagination
              count={rowData?.data?.total_records / rowsPerPage}
              page={page}
              onChange={handlePageChange}
            />
          </Box>
        </>

        <BatchFilterPopup
          open={open}
          onClose={() => setOpen(false)}
          filterValues={filters}
          onChange={handleChange}
          onReset={handleReset}
          onGenerate={handleGenerate}
          data={rowData}
          filterOptions={filterOptions}
          isStatusVisible={true}
        />
        {snack?.open && (
          <SnackBar
            className="popup"
            handleClose={() =>
              setSnack({
                open: false,
                message: "",
                severity: "",
              })
            }
            severity={snack.severity}
            state={snack?.open}
            text={snack?.message}
            autoHide={false}
          />
        )}
      </InvestigatorContainer>
      <ReportPopup
        open={openReportModal}
        onClose={() => setOpenReportModal(false)}
        type={reportType}
        data={reportData}
      />
    </Box>
  );
};

export default Index;
